const wowApp = require('angular').module('wowApp.wallet');

const { digitalPayButtonDirectiveDefinition } = require('./digital-pay-button.directive');

const { digitalPayListItemComponentDefinition } = require('./digital-pay-list-item.component');
const { digitalPayToggleButtonComponentDefinition } = require('./digital-pay-toggle-button.component');
const { digitalPayConfirmationDialogComponentDefinition } = require('./digital-pay-confirmation-dialog.component');

const digitalPayTickStampComponentDefinition = require('./digital-pay-tick-stamp.component');

const DateHelperService = require('./date-helper.service');
const DigitalPayFormValidator = require('./digital-pay-form-validator.service');

wowApp.directive('wowDigitalPayButton', digitalPayButtonDirectiveDefinition);

wowApp.component('wowDigitalPayListItem', digitalPayListItemComponentDefinition);
wowApp.component('wowDigitalPayToggleButton', digitalPayToggleButtonComponentDefinition);
wowApp.component('wowDigitalPayConfirmationDialog', digitalPayConfirmationDialogComponentDefinition);
wowApp.component('wowDigitalPayTickStamp', digitalPayTickStampComponentDefinition);

wowApp.service('DateHelperService', [DateHelperService]);
wowApp.service('DigitalPayFormValidator', ['Settings', DigitalPayFormValidator]);



// WEBPACK FOOTER //
// ./src/wallet/common/index.js